var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoleAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    y2: 21.174,
    y1: 40.846,
    x2: 21.565,
    x1: 11.105,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077d2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0b59a2",
    offset: 1
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    y2: 9.932,
    y1: 25.632,
    x2: 35.418,
    x1: 27.07,
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077d2",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0b59a2",
    offset: 1
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    y2: 21.725,
    y1: 44.99,
    x2: 38.232,
    x1: 25.861,
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffda1c",
    offset: 0.076
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#feb705",
    offset: 1
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1 0 0 -1 0 48)",
    y2: 4.433,
    y1: 27.697,
    x2: 24.814,
    x1: 12.444,
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffda1c",
    offset: 0.076
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#feb705",
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#a)"
    },
    fill: "url(#a)",
    d: "m24 4 1 12.5V25h-8.385L5.49 24C5.18 22.71 5 21.38 5 20v-9c0-.55.45-1 1-1 11.12 0 11.28-6 18-6Z",
    transform: "matrix(.87626 0 0 1 2.97 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#b)"
    },
    fill: "url(#b)",
    d: "M42.51 24c-2.94 12.01-18.08 19.91-18.08 19.91S24.2 44 24 44l-1-12.5 1-7.5 7.917-1Z",
    transform: "matrix(.87626 0 0 1 2.97 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#c)"
    },
    fill: "url(#c)",
    d: "M43 11v9c0 1.38-.18 2.71-.49 4H24V4c6.72 0 6.88 6 18 6 .55 0 1 .45 1 1z",
    transform: "matrix(.87626 0 0 1 2.97 0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#d)"
    },
    fill: "url(#d)",
    d: "M24 24v20c-.22 0-.43-.09-.43-.09S8.43 36.01 5.49 24z",
    transform: "matrix(.87626 0 0 1 2.97 0)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleAdmin);
export default __webpack_public_path__ + "static/media/roleAdmin.f925848df8e0ca94f275972a0a1b4254.svg";
export { ForwardRef as ReactComponent };